import classNames from 'classnames';

export default function Button(props) {
    const { onClick = () => {}, children, style = {}, ...validDomProps } = props;

    const buttonClassName = classNames({
        [props.className]: props.className,
    });

    return (
        <button {...validDomProps} style={style} onClick={onClick} className={buttonClassName}>{children}</button>
    )
}